import React from 'react';
import { ListGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { PurposeTypeBadge } from './PurposeTypeBadge';
import PropTypes from 'prop-types';

export function PurposeListItem({type, object}) {
	const { t, i18n } = useTranslation();

  return (<ListGroup.Item>
    <PurposeTypeBadge type={type} /> <b>[{object.iab_id}]</b> {object.name}
  </ListGroup.Item>)
}

PurposeListItem.propTypes = {
  type: PropTypes.oneOf(['purpose', 'specialFeature']).isRequired,
  object: PropTypes.shape({
    iab_id: PropTypes.number,
    name: PropTypes.string.isRequired
  }).isRequired
}
